import { Field } from 'factorial-form'
import type moment from 'moment'

import { observer } from 'mobx-react'

import DayPicker from 'modules/core/components/DayPicker'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { firstDayOfWeekAsIndex } from 'modules/core/lib/firstDayOfWeek'
import i18n from 'modules/core/lib/i18n'

import { maxDate, minDate } from 'modules/shift_management/lib/getMinMaxDates'

type DateValues = [string | undefined, string | undefined]

export interface Props {
  startDate: Field
  endDate: Field
  hideLabel?: boolean
  minDateFromLeave?: moment.Moment
  maxDateFromLeave?: moment.Moment | null
}

const RangeDatePicker = ({
  startDate,
  endDate,
  hideLabel = false,
  minDateFromLeave,
  maxDateFromLeave,
}: Props) => {
  const {
    access: { firstDayOfWeek },
  } = useCurrentSession()
  const errors = startDate.errors || endDate.errors || []
  const error = errors[0]

  const onChangeEvent = (values: DateValues) => {
    startDate.setErrors([])
    endDate.setErrors([])
    startDate.set(values[0])
    endDate.set(values[1])
  }

  return (
    <DayPicker
      mode="range"
      label={hideLabel ? '' : `${i18n.t('shift_management.no_selection_form.select_period')}:`}
      error={error}
      onChange={onChangeEvent}
      value={[startDate.value, endDate.value]}
      firstDayOfWeek={firstDayOfWeekAsIndex(firstDayOfWeek)}
      focusTrapActive={false}
      minDate={minDateFromLeave || minDate}
      maxDate={maxDateFromLeave || maxDate}
    />
  )
}

export default observer(RangeDatePicker)
